module.exports = __webpack_public_path__ + "img/indian-Unselected.ee0d3952.webp";